import { takeEvery, put, all } from 'redux-saga/effects';

import apiFetcher from '../../../../tools/api-fetcher';
import { openPrintVersion } from '../../../../tools/print-helper';
import handleError from '../../../../tools/error-helper';

import * as types from '../../../../actions/admin/users/candidates/types';
import * as actions from '../../../../actions/admin/users/candidates';
import { loaderDecorator } from '../../../decorators/loader-decorator';

function* fetchFullProfile({ candidateId }) {
  yield put(actions.setCandidateProfileLoading(true));

  yield fetchCandidateProfileBiographicalInformation({ candidateId });
  yield fetchCandidateProfileContactInformation({ candidateId });
  yield fetchCandidateProfileHealth({ candidateId });
  yield fetchCandidateProfileHousingPreferences({ candidateId });
  yield fetchCandidateProfileLanguages({ candidateId });
  yield fetchCandidateProfilePersonal({ candidateId });
  yield fetchCandidateProfileSecondarySchools({ candidateId });
  yield fetchCandidateProfileSportsActivities({ candidateId });
  yield fetchCandidateProfileTeachingCredentials({ candidateId });
  yield fetchCandidateProfileTeachingExperience({ candidateId });
  yield fetchCandidateProfileUniversitiesColleges({ candidateId });

  yield put(actions.setCandidateProfileLoading(false));
}

function* fetchCandidateProfileBiographicalInformation({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `admins/users/candidates/${candidateId}/profile/biographical-information`
      );
    yield put(actions.setCandidateProfileBiagraphicalInfo(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile biograhpical information.');
  }
}

function* fetchCandidateProfileHousingPreferences({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `admins/users/candidates/${candidateId}/profile/housing-preferences`
      );
    yield put(actions.setCandidateProfileHousingPreferences(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile housing preferences.');
  }
}

function* fetchCandidateProfileHealth({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/users/candidates/${candidateId}/profile/health`);
    yield put(actions.setCandidateProfileHealth(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile health section');
  }
}

function* fetchCandidateProfileSportsActivities({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `admins/users/candidates/${candidateId}/profile/sports-and-activities`
      );
    yield put(actions.setCandidateProfileSportsActivities(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile sports and activities.');
  }
}

function* fetchCandidateProfileLanguages({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/users/candidates/${candidateId}/profile/languages`);
    yield put(actions.setCandidateProfileLanguages(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile languages.');
  }
}
function* fetchCandidateProfilePersonal({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/users/candidates/${candidateId}/profile/personal`);
    yield put(actions.setCandidateProfilePersonal(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile personal information.');
  }
}

function* fetchCandidateProfileSecondarySchools({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/users/candidates/${candidateId}/profile/secondary-schools`);
    yield put(actions.setCandidateProfileSecondarySchools(data));
  } catch (exception) {
    handleError(exception);
  }
}

function* fetchCandidateProfileUniversitiesColleges({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/users/candidates/${candidateId}/profile/higher-educations`);
    yield put(actions.setCandidateProfileUniversitiesColleges(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile universities and colleges.');
  }
}

function* fetchCandidateProfileTeachingExperience({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `admins/users/candidates/${candidateId}/profile/teaching-experience`
      );
    yield put(actions.setCandidateProfileTeachingExperience(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile teaching experience.');
  }
}

function* fetchCandidateProfileContactInformation({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `admins/users/candidates/${candidateId}/profile/contact-information`
      );
    yield put(actions.setCandidateProfileContactInfo(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile contact information.');
  }
}

function* fetchCandidateProfileTeachingCredentials({ candidateId }) {
  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `admins/users/candidates/${candidateId}/profile/teaching-credentials`
      );

    yield put(actions.setCandidateProfileTeachingCredencials(data));
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile teaching credentials.');
  }
}

function* printCandidateProfile({ candidateId }) {
  try {
    yield openPrintVersion(
      `/admins/users/candidates/${candidateId}/profile/print-version`
    );
  } catch (exception) {
    handleError(exception, 'Failed to load candidate profile print version.');
  }
}

export default function* candidateProfileSaga() {
  yield all([
    takeEvery(
      types.ADMIN_USERS_CANDIDATE_PROFILE_GET_FULL_PROFILE,
      fetchFullProfile
    ),
    takeEvery(
      types.ADMIN_USERS_PRINT_CANDIDATE_PROFILE,
      loaderDecorator(printCandidateProfile, actions.setPrintVersionIsLoading)
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/admin/users/candidates/admin-users-candidate-profile.js